// @flow
import styled from "styled-components";

export const Content = styled.div`
    text-align: center;
`;

export const Form = styled.div`
    margin: 40px;

    & > button {
        margin-left: 20px;
    }
`;

export const Label1 = styled.div`
    margin: 60px 0 0 0;
`;

export const Label2 = styled.div`
    margin: 10px 0 20px 0;
`;



// WEBPACK FOOTER //
// ./src/home-page-view/password-view/styled.js